import React from 'react';
import { InputRow } from '../../../helpers/uiComponents/InputRow';

class StepOne extends React.Component {
    render() {
        const data = this.props.data;
        const doFunction = this.props.doFunction;

        return(
            <React.Fragment>
                <h4>1. Select a client. All CDE clients and all FYW dealer locations, are available.</h4>
                <p><small>For a FYW location, choose the FYW client, and provide a Dealer ID <em>(found in CDE FYW tool, in the Store Locations info)</em> in the Preferred Location field <em>(visible in step 5)</em>.</small></p>
                {(data && data.length > 0) && (
                    <InputRow 
                        label="Client Name*"
                        type="select"
                        options={data}
                        id="clientCode"
                        onChange={doFunction} />
                )}
            </React.Fragment>
        )
    }
}
export default StepOne;


// WEBPACK FOOTER //
// ./src/component_crmTest/components/TestSteps/StepOne.js